<style scoped>
body {
  overflow: hidden;
  min-height: 100vh !important;
}
.color-primary {
  color: #1a3665;
}
.btn-primary {
  background-color: #1a3665 !important;
}
.btn-outline-primary {
  border: 1.5px solid #1a3665 !important;
  color: #1a3665 !important;
}
.btn-outline-primary:hover {
  background-color: #1a3665 !important;
  color: white !important;
}
.bg-login-half {
  background-image: url("/img/bg-login.jpg");
  background-size: cover;
}
:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: 0.75rem;
}

.login,
.image {
  min-height: 100vh;
}

.bg-image {
  background-image: url("/img/bg-login.jpg");
  background-size: cover;
  background-position: center;
}

.login-heading {
  font-weight: 300;
}

/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
  .form-label-group > label {
    display: none;
  }
  .form-label-group input::-ms-input-placeholder {
    color: #777;
  }
}
</style>
<template>
  <div class="container-fluid bg-white">
    <div class="row no-gutter justify-content-center">
      <div class="col-md-8 col-lg-5">
        <div class="login d-flex align-items-center py-5">
          <div class="container">
            <div class="row">
              <div class="col-md-9 col-lg-8 mx-auto">
                <div class="text-center">
                  <h3 class="text-muted font-weight-bold">Lupa Password ?</h3>
                  <p class="text-muted col-11 mx-auto">
                    Masukkan Email Anda.
                  </p>
                </div>
                <div class="mx-md-3">
                  <v-alert
                  v-if="alert==false"
                    dismissible
                    type="danger"
                    class="alert alert-danger btn-block mt-3 mb-n4"
                  >Alamat Email Tidak Ditemukan!</v-alert>
                  </div>
                <form
                  name="form"
                  v-on:submit.prevent="postForgotPassword"
                  action="#"
                  class="my-xl-5 m-md-3"
                >
                  <div class="form-group">
                    <label class="font-weight-bold">Email</label>
                    <input
                      type="email"
                      class="form-control p-4"
                      placeholder="Masukkan Alamat Email"
                      v-model="formData.email"
                      required
                    />
                  </div>
                  <CButton
                    type="submit"
                    color="primary"
                    size="lg"
                    block="true"
                    class="py-2 mt-4 font-weight-bold"
                  >Kirim</CButton>
                  <router-link to="/pages/login" class="nav-link mt-4 text-center mb-5">
                    <p class="font-weight-bold color-primary">Kembali ke halaman Login</p>
                  </router-link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none col-md-4 col-lg-7 bg-image d-sm-none d-lg-block d-xl-block d-md-none">
        <div class="d-md-flex align-items-center h-100 text-center justify-content-center ml-auto">
          <div class="col-12 d-flex align-items-center h-100 text-white">
            <div class="ml-auto">
               <p class="h1 display-4 font-weight-normal text-right">Selamat Datang di</p>
              <p class="h1 display-4 font-weight-normal text-right">Back Office</p>
              <h5 class="text-right font-weight-bold">Institut Akuntan Publik Indonesia</h5>
              <p class="h4 font-weight-normal mt-3 text-right">Silakan masuk dengan akun anda.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForgotPasswordService from "../../services/auth/forgot-password.service";

export default {
  data() {
    return {
      alert: true,
      formData: {
        email: "",
      },
    };
  },

  methods: {
    // alertError() {
    //   this.$swal.fire({
    //     title: "Peringatan!",
    //     text: "Alamat Email Tidak Ditemukan!",
    //     icon: "error",
    //     showCancelButton: false
    //   });
    // },
    alertSuccess() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-start",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: "Masukkan Kode OTP Yang Telah Kami Kirim!",
      });
    },
    postForgotPassword() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      ForgotPasswordService.postForgotPassword(this.formData)
        .then((response) => {
          // // comment console console.log(response)
          this.alertSuccess();
          loader.hide();
          this.$router.push("/pages/verifikasi/" + this.formData.email);
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
          // this.alertError();
          this.alert = false;
        });
    },
  },
};
</script>
